(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .controller('DocumentoAngController', DocumentoAngController);

    DocumentoAngController.$inject = ['Documento'];

    function DocumentoAngController(Documento) {

        var vm = this;

        vm.documentos = [];

        loadAll();

        function loadAll() {
            Documento.query(function(result) {
                vm.documentos = result;
                vm.searchQuery = null;
            });
        }
    }
})();
